import Immutable from 'seamless-immutable'
import { createReducer } from 'reduxsauce'

import { Types } from './actions'

export const INITIAL_STATE = Immutable({
  contactCenterConnecting: false,
  contactCenterOnline: false,
  contactCenterRetryAttempts: 0,
})

const resetApi = (state) => state.merge({ ...INITIAL_STATE, contactCenterOnline: state.contactCenterOnline })

const contactCenterAttempt = (state) => state.merge({ contactCenterConnecting: true })
const contactCenterSuccess = (state, action) =>
  state.merge({ contactCenterConnecting: false, contactCenterOnline: action.online })
const contactCenterFailure = (state) => state.merge({ contactCenterConnecting: false })
const contactCenterRetry = (state) => state.merge({ contactCenterRetryAttempts: state.contactCenterRetryAttempts + 1 })

const ACTION_HANDLERS = {
  [Types.CONTACT_CENTER_ATTEMPT]: contactCenterAttempt,
  [Types.CONTACT_CENTER_SUCCESS]: contactCenterSuccess,
  [Types.CONTACT_CENTER_FAILURE]: contactCenterFailure,
  [Types.CONTACT_CENTER_RETRY]: contactCenterRetry,

  [Types.RESET_API]: resetApi,
}

export default createReducer(INITIAL_STATE, ACTION_HANDLERS)
